import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import {
Box,  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel
 } from '@mui/material'
import { useAppDispatch, useAppSelector } from 'store'
import styled from 'styled-components'

import { Button } from 'components/atoms/Button'
import { LoadingCircular } from 'components/atoms/LoadingCircular'
import { RequiredStar } from 'components/atoms/RequiredStar'
import { getFullUser, logout,setPolicyAcceptance  } from 'services/authSlice'
import { PATHS } from 'utils/paths'

export const ModalPrivacyPolicyAcceptance = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { state } = useLocation()
  const [openModal, setOpenModal] = useState(false)
  const [checked, setChecked] = useState([false, false, false])
  const user = useAppSelector(getFullUser)

  useEffect(() => {
    // @sieradz - feature/cookieComment (leave for future)
    // if (!user.cookies || !user.privacyPolicyFlag) {
    if (user.privacyPolicyFlag === undefined) {
      return
    } else if (!user.privacyPolicyFlag) {
      setOpenModal(true)
    } else {
      navigate(`${state.path}`)
    }
    // @sieradz - feature/cookieComment (leave for future)
    // }, [user.cookies, user.privacyPolicyFlag])
  }, [user.privacyPolicyFlag])

  const handleChange0 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked([event.target.checked, checked[1], checked[2]])
  }

  // @sieradz - feature/cookieComment (leave for future)
  // const handleChange1 = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   setChecked([checked[0], event.target.checked, checked[2]])
  // }

  const handleChange3 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked([checked[0], checked[1], event.target.checked])
  }

  const acceptanceConsents = () => {
    setOpenModal(false)

    dispatch(
      setPolicyAcceptance({
        userId: user.id,
        privacyPolicyFlag: checked[0],
        // @sieradz - feature/cookieComment (leave for future)
        // cookiesFlag: checked[1],
        newsletterFlag: checked[2]
      })
    )

    return navigate(`${state.path}`)
  }

  if (user.privacyPolicyFlag === undefined) {
    return (
      <Box
        width='100%'
        display='flex'
        flexDirection='column'
        alignItems='center'
        justifyContent='center'
        height='100vh'
      >
        <LoadingCircular />
      </Box>
    )
  }

  return (
    <DialogBox
      sx={{
        boxShadow: `0 4px 4px -1px ${({
          theme
        }: {
          theme: Record<string, any>
        }) => theme.colors.black}`
      }}
      open={openModal}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle
        id='alert-dialog-title'
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginBottom: '16px'
        }}
      >
        Acceptance of Privacy Policy
      </DialogTitle>
      <DialogContent>
        <Wrapper>
          <Note>
            <Paragraph>
              By continuing to use our website, you consent to our Privacy
              Policy.
            </Paragraph>
            <Paragraph>
              Read the{' '}
              <CustomeLink
                to={PATHS.privacyPolicy}
                target='_blank'
                rel='noopener noreferrer'
              >
                Privacy Policy.
              </CustomeLink>
            </Paragraph>
          </Note>
          <Content>
            <FormControlLabel
              label=''
              control={
                <>
                  <Checkbox checked={checked[0]} onChange={handleChange0} />
                  <Paragraph>
                    I consent to the processing of personal data by Digital
                    Shelf Sp. z o.o, for the purpose of use of the application.
                    I confirm that I have read the Privacy Policy.
                    <RequiredStar />
                  </Paragraph>
                </>
              }
            />
            {/* // @sieradz - feature/cookieComment (leave for future) */}
            {/* <FormControlLabel
              label=''
              control={
                <>
                  <Checkbox checked={checked[1]} onChange={handleChange1} />
                  <Paragraph>
                    Agree to the use of Cookies
                    <RequiredStar />
                  </Paragraph>
                </>
              }
            /> */}
            <FormControlLabel
              label=''
              control={
                <>
                  <Checkbox checked={checked[2]} onChange={handleChange3} />
                  <Paragraph>Newsletter</Paragraph>
                </>
              }
            />
          </Content>
          <Content>
            <Buttons>
              <Button variant='outlined' onClick={() => dispatch(logout())}>
                DENIED
              </Button>
              <Button
                variant='primary'
                // @sieradz - feature/cookieComment (leave for future)
                // disabled={!checked[0] || !checked[1]}
                disabled={!checked[0]}
                onClick={() => acceptanceConsents()}
              >
                AGREE
              </Button>
            </Buttons>
          </Content>
        </Wrapper>
      </DialogContent>
    </DialogBox>
  )
}

const DialogBox = styled(Dialog)`
  .MuiBackdrop-root {
    background-color: ${({ theme }) => theme.colors.modalBackdrop};
  }
  .MuiPaper-root {
    padding: 16px;
  }
`
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 24px;
`
const Paragraph = styled.p``
const Buttons = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
`
const Note = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
`
const Content = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
`
const CustomeLink = styled(Link)`
  color: ${({ theme }) => theme.colors.primary};
  font-weight: bold;
`
